import { useCallback, useSyncExternalStore } from "react";

/**
 * Tracks whether a CSS media query matches. Subscribes to changes
 * so the value updates live (e.g. when the user toggles reduced motion).
 */
export function useMatchMedia(query: string): boolean {
    const subscribe = useCallback(
        (onChange: () => void) => {
            const mql = window.matchMedia(query);
            mql.addEventListener("change", onChange);
            return () => mql.removeEventListener("change", onChange);
        },
        [query],
    );

    return useSyncExternalStore(
        subscribe,
        () => window.matchMedia(query).matches,
        () => false,
    );
}
